@import "@/scss/use-bootstrap-mixins";

.carousel_buttons {
  max-width: 47px;
  border: 0;
  background-color: transparent;
  text-align: center;
  padding: 0;

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    .img_wrapper {
      border-color: #d9d9d9;
    }

    path {
      stroke: #d9d9d9 !important;
    }
  }

  .img_wrapper {
    height: 40px;
    width: 40px;
    border: 1px solid #000;
    border-radius: 20px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      path {
        stroke: #000;
      }
    }
  }

  span {
    display: block;
    font-weight: 400;
    font-size: 14px;
    margin-top: 8px;
    color: #000 !important;
  }

  .disabled {
    color: #999 !important;
  }
}
